import React from 'react';
import OlcDeleteIcon from '~/components/General/OlcDeleteIcon';

const TrashNoteCIcon = ({ className }) => (
  <OlcDeleteIcon className={className} size={20} sx={{ color: '#6F737A' }} />
);

export default TrashNoteCIcon;
